/**
 * The one string the client and the proxy both have to spell the same way.
 *
 * `functions/talkPrompt.js` exports its own `UNPROMPTED`, and the client
 * cannot import it: that module is the prompt, and the whole safety
 * argument in TALK.md rests on the client never composing one. So there are
 * two literals, and `npm run talk` asserts they are the same literal - which
 * is the house answer wherever one definition is not possible.
 *
 * Kept in a module of its own, with no imports at all, so a harness can read
 * it without dragging the wire, the catalogues or `localStorage` in behind
 * it.
 */

/** Prefix on the question slot that says: nobody asked this. See watch.ts. */
export const UNPROMPTED = '[[unprompted]]'

/**
 * The marker that says THE RUN THEY CALLED IS BACK.
 *
 * The third kind of line that is not a reply to a question. `UNPROMPTED` is
 * a knock - something happened on the floor and she spoke. This one is
 * narrower: the student called a result, the tool has reported, they have
 * both read it, and the question the result raises has not been asked. See
 * src/talk/predict.ts and TALK.md's "Asking why".
 *
 * Kept here rather than imported from the proxy for the same reason
 * `UNPROMPTED` is: the client cannot import across that seam, and
 * `npm run talk` asserts the two copies still spell it the same.
 */
export const EXPLAIN = '[[explain]]'
